import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from '@mui/material';
import * as api from "api/Core";
import { SpinnerIndicator } from 'components/CallServer';
import MuiRegularButton from 'components/MuiExtras/Button/MuiRegularButton';
import { GridEx } from 'components/MuiExtras/Grid/GridEx';
import MuiAvatar from 'components/MuiExtras/MuiAvatar';
import MuiContainer from 'components/MuiExtras/MuiContainer';
import MuiWidgetTitle from 'components/MuiExtras/MuiWidgetTitle';
import MuiColor from 'components/MuiExtras/Typography/MuiColor';
import { PagedResult, UserCredentialsModel } from 'models/ApiModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from "react-i18next";
import { getCredentialsRenderValues } from 'views/User/Components/UserEditCredentials';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    list: PagedResult<UserCredentialsModel>;
    loading: boolean;
    offset: number;
}

interface IProps {
    userId: string;
}

type Props = IProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class WidgetCredentials extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            list: null,
            offset: 0,
            loading: true
        };
    }

    ///
    private loadData(offset: number, take: number) {
        api.getUserCredentials(this.props.userId, offset, take)
            .then((list) => {
                this.setState({ list, loading: false, offset: offset });
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    }

    ///
    private renderLoadMore() {
        const { list } = this.state;

        if (list.total < 4)
            return null;

        return (
            <GridEx container spacing={1} justifyContent="center" wrap="nowrap">
                <GridEx item>
                    {
                        list.items.length == 3
                            ? <MuiRegularButton color="secondary" simple onClick={() => this.loadData(0, list.total)}>{this.props.t("Common.Feed.Literals.ShowMoreText")}</MuiRegularButton>
                            : <MuiRegularButton color="secondary" simple onClick={() => this.loadData(0, 3)}>{this.props.t("Common.Feed.Literals.ShowLessText")}</MuiRegularButton>
                    }
                </GridEx>
            </GridEx>
        );
    }

    ///
    private renderItems() {
        const { list } = this.state;

        return list.items.map((c) => {
            const p = getCredentialsRenderValues(this.props.i18n, c);

            return (
                <GridEx key={c.index} container spacing={1} justifyContent="space-between" wrap="nowrap">
                    <GridEx item>
                        <MuiAvatar backgroundColor={p.bgColor}>
                            <FontAwesomeIcon icon={p.icon} title={p.iconTitle} />
                        </MuiAvatar>
                    </GridEx>
                    <GridEx item xs zeroMinWidth alignSelf="center">
                        <MuiColor variant="muted">
                            <Typography color="inherit" noWrap variant="subtitle2">{c.description}</Typography>
                            {p.subTitle && <Typography color="inherit" noWrap variant="subtitle2"><small>{p.subTitle}</small></Typography>}
                        </MuiColor>
                    </GridEx>
                </GridEx>
            );
        });
    }

    ///
    private renderContent() {
        return (
            <>
                {this.renderItems()}
                {this.renderLoadMore()}
                <br/>
            </>
        );
    }

    ///
    componentDidMount() {
        this.loadData(0, 3);
    }

    ///
    public render() {
        const { list, loading } = this.state;

        if (!loading && (list == null || list.total == 0))
            return null;


        return (
            <MuiContainer margin="normal" >
                <MuiWidgetTitle title="CREDENCIAIS" />
                {
                    loading
                        ? <SpinnerIndicator />
                        : this.renderContent()
                }

            </MuiContainer >
        );
    }
}

export default withTranslation()(WidgetCredentials);